// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2d4bx","content":"LoadingAlert_content__2dzlo"};